import angular from 'angular';

export default function AddAuditAgencyDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleAddAuditAgencyFormSubmit = handleAddAuditAgencyFormSubmit;
  vm.newAgency = { ...vm.agency };

  /** *********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleAddAuditAgencyFormSubmit() {
    if ($scope.amAddAuditAgencyForm.$invalid) {
      return Promise.resolve();
    }
    vm.newAgency.isActive = true;
    const isNew = vm.newAgency.agencyId < 0;

    if (!isNew && angular.equals(vm.agency, vm.newAgency)) {
      // No need to save
      return _closeDialog();
    }
    loaderService.showViewLoader = true;
    return amSharedModelService.saveAgency(vm.newAgency)
      .then((savedAgency) => {
        angular.extend(vm.newAgency, savedAgency);
        angular.extend(vm.agency, vm.newAgency);
        if (isNew) {
          vm.addCallback(vm.agency);
        } else {
          vm.updateCallback(vm.agency); // provided for legacy event system
        }
        return _closeDialog().then(() => {
          alerts.success('The agency has been saved successfully.');
        });
      })
      .catch(() => {
        alerts.error('An error occurred while saving the agency.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  $rootScope.$broadcast('refreshAMAgencies');
  $rootScope.$broadcast('refreshAMAgency', { agency: vm.agency });

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.addAuditAgencyDialog);
  }
}

AddAuditAgencyDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amSharedModelService',
  'loaderService',
  'ssDialogService'
];
